<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-3">
            <div class="mb-3">
              <router-link to="/marketing" class="btn btn-orange rounded-pill">
                <i class="bx bx-chevron-left"></i> Regresar
              </router-link>
            </div>
          </div>

          <div class="col-lg-3">
            <router-link v-if="solicitudes_no_aprobadas != 0" to="/solicitudes/6">
              <div class="card border-orange">
                <div class="card-body">
                  <div class="row">
                    <div class="col-auto">
                      <div class="stat stat-orange text-orange">
                        <i class="align-middle bx bxs-bell-ring bx-sm"></i>
                      </div>
                    </div>
                    <div class="col mt-0">
                      <h4 class="text-orange mt-2">
                        {{ solicitudes_no_aprobadas }} Solicitudes no aprobadas.
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-3">
            <router-link v-if="solicitudes_pendientes != 0" to="/solicitudes/0">
              <div class="card border-orange">
                <div class="card-body">
                  <div class="row">
                    <div class="col-auto">
                      <div class="stat stat-orange text-orange">
                        <i class="align-middle bx bxs-bell-ring bx-sm"></i>
                      </div>
                    </div>
                    <div class="col mt-0">
                      <h4 class="text-orange mt-2">
                        {{ solicitudes_pendientes }} Solicitudes pendientes.
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-3">
            <router-link to="/solicitudes/7">
              <div class="card border">
                <div class="card-body">
                  <div class="row">
                    <div class="col-auto">
                      <div class="stat text-muted">
                        <i class="align-middle bx bx-list-check bx-sm"></i>
                      </div>
                    </div>
                    <div class="col mt-0">
                      <h4 class="text-muted mt-2">
                        Todas las solicitudes.
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-12">
            <h3 class="text-orange">Impresos</h3>
            <hr />
          </div>
        </div>
      </transition>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-end mb-2">
              <a v-on:click="toggle_filtros()">
                <i class="bx bx-filter-alt"></i>
                <span v-if="mostrar_filtros"> Ocultar filtros</span>
                <span v-if="!mostrar_filtros"> Mostrar filtros</span>
              </a>
            </div>
          </div>
          <div v-if="mostrar_filtros" class="col-lg-12">
            <div class="card card-body">
              <div class="p-4">
                <div class="row">
                  <div class="form-group col-lg-6">
                    <label>Diseñador</label>
                    <select v-model="disenador" v-on:change="get_aliados" class="form-control">
                      <option value="null" selected>Todos</option>
                      <option v-for="disenador in disenadores" :key="disenador.id_usuario_admin" :value="disenador">{{
                        disenador.nombre_completo }}</option>
                    </select>
                  </div>
                  <div class="form-group col-lg-6">
                    <label>Estado solicitud</label>
                    <select v-model="estado_solicitud" v-on:change="get_aliados" class="form-control">
                      <option value="0">Pendiente</option>
                      <option value="1">En desarrollo</option>
                      <option value="2">Terminada</option>
                      <option value="4">Aprobada</option>
                      <option value="5">Cancelada</option>
                      <option value="6">No aprobada</option>
                    </select>
                  </div>
                  <div class="form-group col-lg-6">
                    <label>Periodo de Facturación</label>
                    <!-- <label>Mes de registro</label> -->
                    <input v-on:change="get_aliados" v-model="fecha" type="month" class="form-control" />
                  </div>
                  <div class="col-lg-12">
                    <button class="btn btn-outline-primary btn-sm rounded-pill" v-on:click="getLiquidacion($event)">
                      Liquidar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header"></div>
              <div class="card-body">
                <div v-if="loading_aliados" class="text-center">
                  <div class="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
                <div v-else>
                  <transition appear name="slide-fade">
                    <div v-if="aliados.length != 0">
                      <div class="mt-2 mb-2">
                        <div class="form-group">
                          <label>Buscar</label>
                          <v-select v-model="aliado" @search="get_aliados_search" @input="get_aliados"
                            label="nombre_aliado" :options="aliados_search"></v-select>
                        </div>
                      </div>
                      <div v-if="vista == 2" class="table-responsive">
                        <table class="table table-bordered table-condensed table-hover my_table_1">
                          <thead>
                            <tr>
                              <th style="width: 2%">#</th>
                              <th style="width: 15%">Nombre Aliado</th>
                              <th style="width: 10%">Nombre Diseñador</th>
                              <th style="width: 10%">Fecha de solicitud</th>
                              <th style="width: 10%">Fecha de entrega</th>
                              <th style="width: 5%;">Estado</th>
                              <th style="width: 8%" class="text-center">
                                Ficha
                              </th>
                              <th style="width: 8%" class="text-center">
                                Pieza revista
                              </th>
                              <th style="width: 8%" class="text-center">
                                Pieza redes sociales
                              </th>
                              <th style="width: 8%" class="text-center">
                                Pieza App
                              </th>
                              <th style="width: 8%" class="text-center">
                                Valor
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(aliado, index_aliado) in aliados" v-bind:key="index_aliado">
                              <td>{{ aliado.num }}</td>
                              <td>
                                <router-link v-bind:to="'/aliado/' + aliado.aliado.id_aliado">
                                  <h5 class="text-orange fw-bold mb-0">
                                    {{ aliado.aliado.nombre_aliado }}
                                  </h5>
                                </router-link>
                                <span class="fw-bold text-muted">
                                  {{ aliado.aliado.categoria }} </span><br />
                                <span v-if="aliado.sucursal != null" class="fw-bold text-muted">
                                  {{ aliado.aliado.sucursal.sucursal }}
                                </span>
                              </td>
                              <td class="tex-center">
                                <p v-if="aliado.usuario != null" class="text-orange fw-bold mb-0">{{
                                  aliado.usuario.nombre_completo }}</p>
                                <p v-else> Sin diseñador asignado</p>
                              </td>
                              <td class="tex-center">
                                <p class="text-orange fw-bold mb-0">{{ aliado.fecha_solicitud }}</p>
                              </td>
                              <td class="tex-center">
                                <p class="text-orange fw-bold mb-0">{{ aliado.fecha_entrega }}</p>
                              </td>
                              <td class="tex-center">
                                <span v-if="aliado.estado == 0" class="badge bg-warning">
                                  Pendiente
                                </span>
                                <span v-if="aliado.estado == 1" class="badge bg-info">
                                  En desarrollo
                                </span>
                                <span v-if="aliado.estado == 2" class="badge bg-primary">
                                  Terminada
                                </span>
                                <span v-if="aliado.estado == 4" class="badge bg-success">
                                  Aprobada
                                </span>
                                <span v-if="aliado.estado == 5" class="badge bg-danger">
                                  Cancelada
                                </span>
                                <span v-if="aliado.estado == 6" class="badge bg-warning">
                                  No aprobada
                                </span>
                              </td>
                              <td class="text-center">
                                <router-link v-bind:to="
                                  '/aliado/ficha/' + aliado.aliado.id_aliado
                                " class="btn btn-success rounded-pill" target="_blank"><i
                                    class="bx bxs-check-circle"></i>
                                </router-link>
                              </td>
                              <td class="text-center">
                                <a v-if="aliado.aliado.anexos.pieza_h != null" v-bind:href="aliado.aliado.anexos.pieza_h"
                                  class="btn btn-success rounded-pill" target="_blank"><i class="bx bxs-check-circle"></i>
                                </a>
                                <span v-else class="text-danger">
                                  <router-link v-bind:to="
                                    '/cargar_anexo/' +
                                    aliado.aliado.id_aliado +
                                    '/' +
                                    5
                                  " style="color:#dc3545;">
                                    <i class='bx bx-upload bx-sm'></i>
                                  </router-link>
                                </span>
                              </td>
                              <td class="text-center">
                                <a v-if="aliado.aliado.anexos.pieza_v != null" v-bind:href="aliado.aliado.anexos.pieza_v"
                                  class="btn btn-success rounded-pill" target="_blank"><i class="bx bxs-check-circle"></i>
                                </a>
                                <span v-else class="text-danger">
                                  <router-link v-bind:to="
                                    '/cargar_anexo/' +
                                    aliado.aliado.id_aliado +
                                    '/' +
                                    6
                                  " style="color:#dc3545;">
                                    <i class='bx bx-upload bx-sm'></i>
                                  </router-link>
                                </span>
                              </td>
                              <td class="text-center">
                                <a v-if="aliado.aliado.anexos.pieza_a != null" v-bind:href="aliado.aliado.anexos.pieza_a"
                                  class="btn btn-success rounded-pill" target="_blank"><i class="bx bxs-check-circle"></i>
                                </a>
                                <span v-else class="text-danger">
                                  <router-link v-bind:to="
                                    '/cargar_anexo/' +
                                    aliado.aliado.id_aliado +
                                    '/' +
                                    9
                                  " style="color:#dc3545;">
                                    <i class='bx bx-upload bx-sm'></i>
                                  </router-link>
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="aliado.estado == 4">
                                  {{ 5000 | currency }}
                                </span>
                                <span v-else>
                                  {{ 0 | currency }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div v-else>
                      <div class="text-muted">
                        <i class="bx bx-info-circle"></i> No se encontraron
                        aliados.
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="mt-4 mb-4" aria-label="Page navigation example" v-html="paginate"></div>
          </div>
        </div>
      </transition>
      <modal name="modal_liquidacion" :adaptive="true" height="auto">
        <div class="card m-4" id="element-to-convert">
          <div class="card-header">
            <h2 class="fw-bold text-orange">Liquidacion Solicitudes</h2>
          </div>
          <div class="card-body" v-if="disenador != null" style="height:70vh;overflow-y:scroll">
            <div class="row">
              <div class="col-md-12">
                <h2>Diseñador:</h2>
                <h4>{{ disenador.nombre_completo }}</h4>
                <br>
              </div>
              <div class="col-md-6">
                <h2>Fecha generación:</h2>
                <h4>{{ today.getFullYear() + '-' + today.getMonth() + '-' + today.getDate() }}</h4>
                <br>
              </div>
              <div class="col-md-6">
                <h2>Fecha liquidada:</h2>
                <h4>{{ fecha }}</h4>
                <br>
              </div>
            </div>
            <h2>Detalle liquidación</h2>
            <table class="table table-bordered table-condensed table-hover my_table_1">
              <thead>
                <tr>
                  <th style="width: 2%">#</th>
                  <th style="width: 15%">Nombre Aliado</th>
                  <th style="width: 8%" class="text-center">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(aliado, index_aliado) in aliados" v-bind:key="index_aliado">
                  <td>{{ aliado.num }}</td>
                  <td>
                    <router-link v-bind:to="'/aliado/' + aliado.aliado.id_aliado">
                      <h5 class="text-orange fw-bold mb-0">
                        {{ aliado.aliado.nombre_aliado }}
                      </h5>
                    </router-link>
                    <span class="fw-bold text-muted">
                      {{ aliado.aliado.categoria }} </span><br />
                    <span v-if="aliado.sucursal != null" class="fw-bold text-muted">
                      {{ aliado.aliado.sucursal.sucursal }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span v-if="aliado.estado == 4">
                      {{ 5000 | currency }}
                    </span>
                    <span v-else>
                      {{ 0 | currency }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <br>
            <h2>Total a Pagar:</h2>
            <h4>
              {{ total_liquidacion | currency }}
            </h4>
            <hr />
            <div class="text-end">
              <button class="btn btn-outline-secondary rounded-pill" @click="exportToPDF()">Export to PDF</button>
              <button @click="$modal.hide('modal_liquidacion')" class="btn btn-outline-secondary rounded-pill">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
import html2pdf from "html2pdf.js";
export default {
  name: "Marketing_impresos",
  metaInfo: {
    title: "Impresos - Reddy Backoffice",
  },
  data() {
    return {
      loading: true,
      disenador: null,
      fecha: null,
      disenadores: [],
      loading_aliados: true,
      loading_solicitudes: true,
      sucursal: null,
      page: 1,
      aliados: [],
      paginate: null,
      vista: 2,
      mostrar_filtros: false,
      aliados_search: [],
      aliado: null,
      estado_solicitud: null,
      solicitudes_pendientes: 0,
      solicitudes_no_aprobadas: 0,
      today: new Date(),
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.page = this.$route.params.page;
    var sucursal = localStorage.getItem("sucursal");
    if (sucursal != undefined) {
      this.sucursal = JSON.parse(sucursal);
    }

    this.get_aliados();
    this.get_sucursales();
    this.get_diseñadores();
    var mostrar_filtros = localStorage.getItem("mostrar_filtros");
    if (mostrar_filtros != undefined) {
      if (mostrar_filtros == "true") {
        this.mostrar_filtros = true;
      } else {
        this.mostrar_filtros = false;
      }
    }
    var vista = localStorage.getItem("vista");
    if (vista != undefined) {
      this.vista = vista;
    }
    this.get_sucursales();
    this.get_solicitudes();
    this.get_solicitudes_no();
  },
  methods: {
    exportToPDF() {
      html2pdf(document.getElementById("element-to-convert"), {
        margin: 1,
        filename: "liquidacion.pdf",
      });
    },
    get_diseñadores: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "admin/disenadores/" + this.id_aliado, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          console.log(response.data)
          this.disenadores = response.data.disenadores;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_aliados: function () {
      this.loading_aliados = true;
      var id_sucursal = null;
      if (this.sucursal != null) {
        id_sucursal = this.sucursal.id_sucursal;
        localStorage.setItem("sucursal", JSON.stringify(this.sucursal));
      }
      var id_aliado = null;
      if (this.aliado != null) {
        id_aliado = this.aliado.id_aliado;
      }
      var id_disenador = null;
      if (this.disenador != null) {
        id_disenador = this.disenador.id_usuario_admin;
      }
      console.log(this.disenador)
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          page: this.page,
          id_sucursal: id_sucursal,
          id_aliado: id_aliado,
          id_disenador: id_disenador,
          fecha: this.fecha,
          estado: this.estado_solicitud
        },
      };
      axios
        .get(this.$base_url + "aliados/aliados_marketing_piezas", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliados = response.data.data.solicitudes;
          this.total_aliados = response.data.data.total_aliados;
          this.get_paginate(response.data.data.total_pages);
          this.loading = false;
          this.loading_aliados = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_solicitudes: function () {
      this.loading_solicitudes = true;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          estado: 0,
        },
      };
      axios
        .get(this.$base_url + "aliados/solicitudes_piezas", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.solicitudes_pendientes = response.data.data.pendientes;
          this.loading_solicitudes = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_solicitudes_no: function () {
      this.loading_solicitudes = true;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          estado: 6,
        },
      };
      axios
        .get(this.$base_url + "aliados/solicitudes_piezas", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.solicitudes_no_aprobadas = response.data.data.no_aprobadas;
          this.loading_solicitudes = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_sucursales: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "admin/sucursales", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.sucursales = response.data.data.sucursales;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_paginate: function (tpages) {
      var page = this.page;

      if (page === undefined || page <= 0) {
        this.page = 1;
        page = this.page;
      }

      var adjacents = 4;

      var paginate = null;

      paginate = '<ul class="pagination justify-content-center text-center">';
      // previous label
      if (page == 1) {
        paginate +=
          "<li class='paginate_button page-item previous disabled'><a class='page-link disabled'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      } else if (page == 2) {
        paginate +=
          "<li class='paginate_button page-item  previous'><a href='#/impresos/1' class='page-link' href='javascript:void(0);'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      } else {
        var page_ant = parseFloat(page) - 1;
        paginate +=
          "<li class='paginate_button page-item'><a href='#/impresos/" +
          page_ant +
          "' class='page-link' href='javascript:void(0);'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      }
      // first label
      if (page > parseFloat(adjacents) + 1) {
        paginate +=
          "<li class='paginate_button page-item'><a class='page-link' href='#/impresos/1'>1</a></li>";
      }
      // interval
      if (page > parseFloat(adjacents) + 2) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // pages
      var pmin =
        page > adjacents ? parseFloat(page) - parseFloat(adjacents) : 1;
      var pmax =
        page < parseFloat(tpages) - parseFloat(adjacents)
          ? parseFloat(page) + parseFloat(adjacents)
          : tpages;

      for (var i = pmin; i <= pmax; i++) {
        if (i == page) {
          paginate +=
            "<li class='paginate_button page-item active'><a href='#/impresos/" +
            i +
            "' class='page-link'>" +
            i +
            "</a></li>";
        } else if (i == 1) {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/impresos/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        } else {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/impresos/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        }
      }
      // interval
      if (page < parseFloat(tpages) - parseFloat(adjacents) - 1) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // last
      if (page < parseFloat(tpages) - parseFloat(adjacents)) {
        paginate +=
          "<li class='paginate_button page-item'><a  href='#/impresos/" +
          tpages +
          "' class='page-link' href='javascript:void(0);'>" +
          tpages +
          "</a></li>";
      }
      // next
      if (page < tpages) {
        var page_next = parseFloat(page) + 1;
        paginate +=
          "<li class='paginate_button page-item next'><a  href='#/impresos/" +
          page_next +
          "' class='page-link' href='javascript:void(0);'> <span aria-hidden='true'>&raquo;</span> </a></li>";
      } else {
        paginate +=
          "<li class='paginate_button page-item next disabled'><a class='page-link disabled'> <span aria-hidden='true'>&raquo;</span> </a></li>";
      }
      paginate += "</ul>";
      this.paginate = paginate;
    },
    get_aliados_search: function (search) {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          search: search,
        },
      };
      axios
        .get(this.$base_url + "aliados/aliados", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliados_search = response.data.data.aliados;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    getLiquidacion: function () {
      this.total_liquidacion = 0;
      if (this.fecha == null || (this.estado_solicitud != 4 || this.disenador == null)) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Solo se pueden liquidar Solicitudes aprobadas con fecha seleccionada y diseñador",
        });
      } else {
        let solicitudes = [];
        this.aliados.forEach(solicitud => {
          let newsolicitud = solicitud;
          if (newsolicitud.estado == 4) {
            newsolicitud.liquidacion_usuario = 5000;
          } else {
            newsolicitud.liquidacion_usuario = 0;
          }

          newsolicitud.liquidacion_total_usuario = newsolicitud.liquidacion_usuario;
          this.total_liquidacion += newsolicitud.liquidacion_total_usuario;
          solicitudes.push(newsolicitud);
        });
        this.aliados = solicitudes;
        console.log(this.solicitudes)
        console.log(this.total_liquidacion)
        this.$modal.show("modal_liquidacion");
      }
    },
    toggle_filtros: function () {
      this.mostrar_filtros = !this.mostrar_filtros;
      localStorage.setItem("mostrar_filtros", this.mostrar_filtros);
    },
    toggle_vista: function (vista) {
      this.vista = vista;
      localStorage.setItem("vista", this.vista);
    },
  },
  mounted: function () { },
  watch: {
    $route() {
      this.page = this.$route.params.page;
      this.get_aliados();
    },
  },
};
</script>